import React, { useState , useEffect, useContext} from 'react'
import './livedocument.css'
import '../AffidavitTemp/affidavit.css'
import Sidebar from '../../../components/Sidebar/Sidebar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClockRotateLeft, faFileLines, faSearch, faRefresh, faDownload, faDesktop } from '@fortawesome/free-solid-svg-icons'
import { useNavigate,Link , useParams  } from 'react-router-dom'
import BackLoader from '../../../components/backloader'
import * as Constants from '../../../constants';
import { ShareContext } from '../../../context/ShareContext'
import TopBar from '../../../components/topbar'
import moment from 'moment'
import JisAlert from '../../../components/jisalert'
import { colors } from '@mui/material'
import { red } from '@mui/material/colors'

function LiveDocumentFrameAdr() {

    const { profile,setIsHeader } = useContext(ShareContext)
  //  const {type} = useParams();//case or fee
    const {id} = useParams(); //fee id or caseid= default to caseid
    

  

    const [docs, setDocs] = useState([]);
    const [caseInfo, setCaseInfo]=useState({});
    const [refs, setRefs]=useState([]);
    const [isLoading,setIsLoading]= useState(false);
    const [schedule, setSchedule]= useState({});
    const [alert, setAlert] = useState({open:false})
    const [search, setSearch]= useState('');
    const [currectdoc, setCurrentDoc]=useState({});
    const [previewWindow, setPreviewWindow] = useState(false)
    const [pageIndex, setPageIndex]=useState(0);
    const [filenames, setFilenames] =useState([]);
    const [caseType, setCaseType] =useState("litigation");
    const profileid=  Constants.getCookie("profilename");
  var url= `${Constants.apiUrl}/gazette/adr/ApprovedDocuments/case/${id}/${profileid}`;
    const navigate = useNavigate();
    useEffect(() => {
      setIsHeader(false);
        if(id!=null){
            onCaseId();
        }
      }, [profileid]);


   

  
    const onView=(item)=>{
       //for Preview
       
       setPageIndex(0);
       setPreviewWindow(true);
       setCurrentDoc(item)
       onCurrentDoc(item.documentId);

 }
 const onSearch= async()=>{
    //for account registration
    var surl= `${Constants.apiUrl}/gazette/adr/ApprovedDocuments/search/${encodeURIComponent(search) }/${profile.username}`;
    console.log(`the calling url ${surl}`);
    try {
        setIsLoading(true);
        const resp = await fetch(surl, { 
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': '',
          },
        });
        
        const data = await resp.json();
        console.log(' search result');
        console.log(data);
        setIsLoading(false);
        if(data.code==0){
            setDocs(data.files);
            setCaseInfo(data.ccased);
        }
        else {    
            alert(data.status);
        }
      } catch (error) {
        setIsLoading(false);
        console.error(error);
        
      }
}

const onCaseId= async()=>{
    //for account registration
   
    console.log(`the calling url ${url}`);
    try {
        setIsLoading(true);
        const resp = await fetch(url, { 
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': '',
          },
        });
        
        const data = await resp.json();
        console.log(' search result');
        console.log(data);
        setIsLoading(false);
        if(data.code==0){
            setDocs(data.files);
            setCaseInfo(data.ccased);
        }
        else {    
            alert(data.status);
        }
      } catch (error) {
        setIsLoading(false);
        console.error(error);
        
      }
}

const onCurrentDoc= async(id)=>{ //doctype=upline always this one
    //for account registration DocumentView
    const url=`${Constants.apiUrl}/gazette/adr/singlelivefile/${id}`

    console.log(`the calling url ${url}`);
    try {
        setIsLoading(true);
        const resp = await fetch(url, { 
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': '',
          },
        });
        
        const data = await resp.json();
        setIsLoading(false);
        console.log('specific document');
        console.log(data);
        if(data.code==0 ){
            setFilenames(data.filenames);
        }else{
            alert(data.status);
        }
      } catch (error) {
        setIsLoading(false);
        console.error(error);
        alert('The file cannot be preview')
        
      }
}

const onDownload= async(doc)=>{ //doctype=upline always this one
    //for account registration DocumentView
    const url=`${Constants.apiUrl}/gazette/adr/downloadlivefile/${doc.documentId}`

    console.log(`the calling url ${url}`);
    try {
        setIsLoading(true);
        const resp = await fetch(url, { 
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': '',
            'responseType': 'blob'
          },
        });
        
        const data = await resp.blob();
        setIsLoading(false);
        console.log('specific document');
        const blob = new Blob([data], {type: 'application/pdf'});
            const link = document.createElement('a');
            link.download =doc.documentName;// 'some.pdf';
            link.href = URL.createObjectURL(blob);
            link.click();
      } catch (error) {
        setIsLoading(false);
        console.error(error);
        
      }
}
const onNextPage=()=>{
    if(pageIndex < filenames.length-1){
        var ipage=pageIndex+1;
        setPageIndex(ipage);
    }else{
        console.log('its not there again '+pageIndex);
    }
}

const onPrevPage=()=>{
     if(pageIndex > 0){
        var ipage=pageIndex-1;
        setPageIndex(ipage);
    }else{
        console.log('its not there again '+pageIndex);
    }
}

const onNewDocument=()=>{
navigate(`/adr/gazette/${caseInfo.caseId}`)
}

  return (
    <div className='appointments'>
        
        <div className="body">
         

            

            <div className="aff-table">
                <div className="all-div">
                    <FontAwesomeIcon icon={faFileLines} />
                    <h3>{caseInfo.caseNumber}</h3> <span>{caseInfo.title}</span>
                </div>
                <div className="table-wrapper">
                    <table>
                        <thead>
                            <tr>
                            <th>Document Name</th>
                                <th> Document Type</th>
                                <th>Date of Upload</th>
                                <th></th>
                                  <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                docs.map((doc, i) => { return (
                                    <tr key={i} style={currectdoc.documentId==doc.documentId?{backgroundColor:red[100] }:{}}>
                                        <td>{doc.documentName}</td>
                                        {/* <td> {doc.documentType}</td> */}
                                        <td className={'meet-link'}>  {doc.documentType} </td>
                                        <td> {doc.createdDate}</td>
                                        
                                      { <td className='schedule-zoom' onClick={() => onDownload(doc) }> Download <FontAwesomeIcon icon={faDownload} /></td>}    
                                       <td className='schedule-zoom' onClick={() => onView(doc) }> View Document <FontAwesomeIcon icon={faDesktop} /> </td>
                                    </tr>
                                )})
                            } 
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="footer-tech">
                <p>Powered By First Hightower InfoTech</p>
                <p>© 2024</p>
            </div>
          {previewWindow && <div className={  "pick-date open" } style={{overflow:'scroll'}}>
                <div className="heading">
                    <h2>Preview </h2>
                    <span>Pages <strong>{pageIndex+1 }</strong></span>
                </div>
               
                {filenames.length>0 && <img src={Constants.AbsoluteFiletoRelative(filenames[pageIndex])} style={{width:'100%', margin:0}} />} 
                <div>{filenames.length>1 && <>
                <strong>{pageIndex+1 } / {filenames.length}</strong> 
        
        <button onClick={onPrevPage} className='planred'>Previous Page</button> 
        <button  onClick={onNextPage} type='button' className='planred'>Next Page</button>
                </>}  <button className="planred" onClick={() => {setPreviewWindow(false); setCurrentDoc({})}}>Close</button></div>
                <div className="date-btns">
                    
                  
                </div>
            </div>}  
          {alert.open && <JisAlert {...alert}/>}  
          <BackLoader open={isLoading}  />
        </div>
    </div>
  )
}

export default LiveDocumentFrameAdr